export const EMPTY_CONTRACT_FILTERS = {
  client: null,
  company: '',
  situation: '',
  status: '',
  dateStart: '',
  dateEnd: '',
  financingType: '',
  model: '',
};
